import { connect } from 'react-redux'
import PromotionsPane from '../../components/promotions/PromotionsPane'
import { IStoreState } from '../../types/index'

const mapStateToProps = (state: IStoreState) => {
  return {
    currentOrgId: state.organizations.currentOrgId
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PromotionsPane)



// WEBPACK FOOTER //
// ./src/containers/promotions/PromotionsPane.ts